// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"3100326e","868":"55eeef78","881":"75d1ac67"}[chunkId] + ".chunk.js";
};